import { getCountryData } from './casesMap';

const $ = jQuery;
const $taxonomies = $('.js-cases-map--taxonomy');

export function cases() {
    // Only run if cases-map block is present
    if (!document.querySelector('section.cases-map')) {
        return;
    }
    
    if ($taxonomies.length === 0) {
        return;
    }

    // Taxonomy trigger
    $taxonomies.find('.cases-map__taxonomy-trigger').on('click', function () {
        const $this = $(this);
        const $parent = $this.closest('.cases-map__taxonomy');
        const $list = $parent.find('.cases-map__taxonomy-list');

        $taxonomies.not($parent).find('.cases-map__taxonomy-list').slideUp();
        $taxonomies.not($parent).removeClass('active');

        $list.slideToggle();
        $parent.toggleClass('active');
    });

    // Taxonomy trigger accordion
    $taxonomies.find('.cases-map__taxonomy-trigger-accordion').on('click', function () {
        const $this = $(this);
        const $wrap = $this.closest('.cases-map__taxonomy-sublist-wrap');
        const $siblings = $this.siblings('.cases-map__taxonomy-sublist');

        $siblings.slideToggle();
        $wrap.toggleClass('active');
    });

    // Click outside taxonomy trigger
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.cases-map__taxonomy').length) {
            $taxonomies.removeClass('active');
            $taxonomies.find('.cases-map__taxonomy-list').slideUp();
        }
    });

    // Taxonomy item change
    $taxonomies.find('.cases-map__taxonomy-item input').on('change', function () {
        const searchValue = $('.js-cases-map--search').val();
        let cases = [];
        
        // Check if casesData exists and has cases data
        if (typeof casesData !== 'undefined' && casesData.cases) {
            cases = casesData.cases;
        }
        
        cases = cases.filter((item) => {
            return item.title.toLowerCase().includes(searchValue.toLowerCase());
        });

        const filteredCases = getCasesFromActiveTaxonomies(cases);
        handleCaseVisibility(filteredCases);

        // check do we have any input checked
        checkIsAnyFilterApplied();
    });

    // Meta search filters
    $('.js-cases-map--meta-search-filters').on('click', function () {
        const $this = $(this);
        const $wrapper = $('.js-cases-map--taxonomies-wrapper');

        $wrapper.slideToggle();
        $this.toggleClass('active');
        $wrapper.toggleClass('active');
        handleMobileTaxonomyWrapper();
    });

    // Meta view change
    $('.js-cases-map--meta-view').on('click', function () {
        checkIsAnyFilterApplied();
        const $this = $(this);
        const type = $this.data('view');

        if (type === 'list') {
            $('.js-cases-map--container').hide();
            $('.js-cases-map--posts-container').show();
        } else {
            $('.js-cases-map--container').show();
            $('.js-cases-map--posts-container').hide();
        }

        $this.addClass('active');
        $this.siblings().removeClass('active');
    });

    // Handle search
    $('.js-cases-map--search').on('keyup', function () {
        const $this = $(this);
        const value = $this.val();
        let cases = [];
        
        // Check if casesData exists and has cases data
        if (typeof casesData !== 'undefined' && casesData.cases) {
            cases = casesData.cases;
        }
        
        cases = getCasesFromActiveTaxonomies(cases);
        const filteredCases = cases.filter((item) => {
            const searchValue = value.toLowerCase();
            const titleMatch = item.title.toLowerCase().includes(searchValue);
            const excerptMatch = item.excerpt && item.excerpt.toLowerCase().includes(searchValue);
            return titleMatch || excerptMatch;
        });

        checkIsAnyFilterApplied();
        handleCaseVisibility(filteredCases);
    });

    // Clear taxonomies
    $('.js-cases-map--clear-filters, .js-cases-map--reset').on('click', function () {
        clearTaxonomies();
        handleMobileTaxonomyWrapper();
        const $wrapper = $('.js-cases-map--taxonomies-wrapper');
        $wrapper.slideUp();
        $wrapper.removeClass('active');
        $('.js-cases-map--meta-search-filters').removeClass('active');
        $('.js-cases-map--clear-filters').addClass('hidden');
        $('.cases-map__no-results').addClass('disabled');

        $('.js-cases-map--search').val('');
    });

    // Apply taxonomies
    $('.js-cases-map--apply').on('click', function () {
        handleMobileTaxonomyWrapper();
        const $wrapper = $('.js-cases-map--taxonomies-wrapper');
        $wrapper.slideUp();
        $wrapper.removeClass('active');
        $('.js-cases-map--meta-search-filters').removeClass('active');
    });

    // Check do we have query in url term, if have, apply it
    const urlParams = new URLSearchParams(window.location.search);
    const term = urlParams.get('term');
    if (term) {
        const input = $(`.cases-map__taxonomy-item input[value="${term}"]`);
        if (input.length) {
            input.prop('checked', true);
            input.trigger('change');
        }

        if ($('.js-cases-map--meta-view.active').data('view') === 'list') {
            $('.js-cases-map--container').hide();
            $('.js-cases-map--container').css('opacity', 1);
        }
    }

    $(window).on('resize', function () {
        $('.js-cases-map--taxonomies-wrapper-mobile').removeClass('active');
    });
}

function handleCaseVisibility(cases) {
    const ids = getIdsFromCases(cases);
    let countries = [];
    cases.forEach((item) => {
        item.countries.forEach((country) => {
            if (!countries.includes(country)) {
                countries.push(country);
            }
        });
    });

    $('.js-case-map--card, .card-post').each(function () {
        const $this = $(this);
        const id = $this.data('post-id');
        if (!ids.includes(id)) {
            $this.hide();
        } else {
            $this.show();
        }
    });

    if (cases.length === 0) {
        $('.cases-map__no-results').removeClass('disabled');
    }

    getCountryData(countries);
}

function getIdsFromCases(cases) {
    return cases.map((item) => item.id);
}

function getTaxonomies() {
    let taxonomies = {};
    let $currentTaxonomies;

    if (window.innerWidth < 1024) {
        $currentTaxonomies = $('.js-cases-map--taxonomies-wrapper-mobile .js-cases-map--taxonomy');
    } else {
        $currentTaxonomies = $('.js-cases-map--taxonomies-wrapper .js-cases-map--taxonomy');
    }

    $currentTaxonomies.each(function () {
        const $this = $(this);
        const taxonomy = $this.data('taxonomy');

        taxonomies[taxonomy] = $this
            .find('.cases-map__taxonomy-item input:checked')
            .map(function () {
                return $(this).val();
            })
            .get();
    });

    return taxonomies;
}

function getCasesFromActiveTaxonomies(cases) {
    const taxonomies = getTaxonomies();
    let activeTermIds = [];
    for (const [key, value] of Object.entries(taxonomies)) {
        for (const termId of value) {
            activeTermIds.push(parseInt(termId));
        }
    }

    let filteredCases = [];
    cases.forEach(function (item) {
        // Check if the case has ALL the selected term IDs
        const hasAllTerms = activeTermIds.every((termId) => item.termIds.includes(termId));
        if (hasAllTerms) {
            filteredCases.push(item);
        }
    });

    return filteredCases;
}

function clearTaxonomies() {
    $('.js-cases-map--taxonomy').removeClass('active');
    $('.js-cases-map--taxonomy-list').slideUp();
    $('.cases-map__taxonomy-item input').prop('checked', false);
    
    let cases = [];
    // Check if casesData exists and has cases data
    if (typeof casesData !== 'undefined' && casesData.cases) {
        cases = casesData.cases;
    }
    
    handleCaseVisibility(cases);
}

function handleMobileTaxonomyWrapper() {
    $('.js-cases-map--taxonomies-wrapper-mobile').toggleClass('active');
}

function checkIsAnyFilterApplied() {
    const $inputs = $taxonomies.find('.cases-map__taxonomy-item input:checked');
    const searchValue = $('.js-cases-map--search').val();
    const $clearFilters = $('.js-cases-map--clear-filters');

    if ($inputs.length > 0 || searchValue.length > 0) {
        $clearFilters.removeClass('hidden');
    } else {
        $clearFilters.addClass('hidden');
    }
}
